import { SELECT_MANY } from '../../components/ShareEstimate/steps/stepTypes';

export default state => ({
  ...state,
  shareModalOpen: false,
  shareStep: SELECT_MANY,
});
